{
  "eyebrow": "Wybierz swój plan",
  "title": "Plan dopasowany do sposobu pracy Twojego zespołu.",
  "sub": "30 dni bezpłatnej próby w każdym planie. Bez karty kredytowej. Anuluj w dowolnym momencie.",
  "bill": {
    "month": "Miesięcznie",
    "year": "Rocznie",
    "save": "Oszczędź 15%"
  },
  "fam": {
    "time": "Czas i operacje",
    "project": "Projekty i kontrola kosztów"
  },
  "compare": "Porównaj wszystkie funkcje",
  "compareHide": "Ukryj porównanie",
  "included": "W cenie",
  "select": "Wybierz {{plan}}",
  "selected": "Wybrano",
  "recommended": "Najpopularniejszy",
  "pricePerMonth": "/ użytkownik / miesiąc",
  "pricePerYear": "/ użytkownik / rok",
  "base": "baza / miesiąc",
  "admins": "2 administratorów w cenie",
  "continueCta": "Kontynuuj z {{plan}}",
  "continuePick": "Wybierz plan, aby kontynuować",
  "catalogError": "Katalog cen niedostępny. Spróbuj ponownie, aby załadować aktualne ceny.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Zgodność i proste rozliczenia",
    "timeProBest": "Operacje zespołu",
    "projectBasicBest": "Projekty i kontrola kosztów",
    "projectProBest": "Zaawansowane zarządzanie projektami",
    "feat": {
      "timeBasic": {
        "timeTracking": "Rejestracja czasu pracy",
        "absencesHolidays": "Nieobecności i urlopy",
        "transport": "Rejestry transportowe",
        "workLocations": "Miejsca pracy i GPS",
        "mobileApp": "Aplikacja mobilna dla pracowników w terenie"
      },
      "timePro": {
        "everythingTime": "Wszystko z Time Basic",
        "overtime": "Rejestracja nadgodzin",
        "scheduling": "Harmonogramowanie zmian",
        "documents": "Dokumenty pracowników",
        "officeOps": "Funkcje biurowe (dziennik aktywności, korekty)",
        "addonsAvailable": "Dostępne dodatki: śledzenie projektów, VTT",
        "internalMessaging": "Wiadomości wewnętrzne (czat firmowy)"
      },
      "projectBasic": {
        "everythingTime": "Wszystko z Time Basic",
        "projects": "Projekty z kontrolą kosztów",
        "extras": "Prace dodatkowe i materiały dodatkowe",
        "subcontractors": "Zarządzanie podwykonawcami",
        "checkInOut": "Wejścia / wyjścia pracowników",
        "internalMessaging": "Wiadomości wewnętrzne (czat firmowy)"
      },
      "projectPro": {
        "everythingAll": "Wszystko z Time Pro + Project Basic",
        "projectTransport": "Transport powiązany z projektem",
        "fullSuite": "Pełny zestaw produktywności",
        "prioritySupport": "Pomoc priorytetowa",
        "internalMessaging": "Wiadomości wewnętrzne (czat firmowy)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Porównaj wszystkie funkcje",
    "subtitle": "Wszystko, co zawiera każdy plan, obok siebie.",
    "cat": {
      "timeAttendance": "Czas i obecność",
      "projectCost": "Projekt i kontrola kosztów",
      "support": "Wsparcie"
    },
    "val": {
      "upTo4": "Do 4",
      "unlimited": "Bez limitu",
      "soon": "Wkrótce",
      "optional": "Opcjonalnie",
      "years5": "5 lata",
      "years10": "10 lat"
    },
    "row": {
      "mobileDesktop": "Aplikacja mobilna i desktopowa",
      "gpsCheckin": "Odbicie jednym dotknięciem z GPS",
      "holidayAbsenceOvertime": "Urlopy, nieobecności i nadgodziny",
      "teamMembers": "Członkowie zespołu",
      "workLocations": "Lokalizacje pracy",
      "registrationsPerMonth": "Rejestracje / użytkownik / miesiąc",
      "irregularMap": "Nieregularne odbicia na mapie",
      "expenseManagement": "Zarządzanie wydatkami",
      "employeeDocuments": "Dokumenty pracowników",
      "openApi": "Otwarte API",
      "navigation": "Nawigacja do miejsc pracy",
      "projectManagement": "Zarządzanie projektami (budżet)",
      "subprojects": "Podprojekty",
      "subcontractorManagement": "Zarządzanie podwykonawcami",
      "extraWorkMaterials": "Dodatkowe prace i materiały",
      "transportProjects": "Transport powiązany z projektami",
      "fullSuite": "Pełny pakiet produktywności",
      "prioritySupport": "Wsparcie priorytetowe",
      "languages12": "Dostępne w 12 językach",
      "manualTransport": "Ręczna odległość transportu",
      "reportsExcel": "Raporty i eksport do Excela",
      "frontendLocations": "Lokalizacje tworzone przez użytkowników aplikacji",
      "checkInWork": "Check-in/out@work (Belgia)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Opisy i zdjęcia projektów",
      "dataStorage": "Przechowywanie danych",
      "schedulingPlanning": "Planowanie",
      "messagingNotifications": "Wiadomości · Powiadomienia"
    }
  }
}
